/**
 * Read-only indicator that a question randomizes its option order. Rendered in
 * QuizDetail's question list and the Analytics PagesTable row. Reuses the admin
 * mono/orange chip idiom; introduces no new tokens.
 */
export function RandomizedChip() {
  return (
    <span className="mono rounded border border-mars-orange/45 bg-mars-orange/10 px-1.5 py-0.5 text-[0.55rem] uppercase tracking-[0.12em] text-mars-orange">
      Randomized
    </span>
  );
}
